module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/utility/transaction-history/transaction-history.component.css
// module id = ./src/app/modules/housekeeping/utility/transaction-history/transaction-history.component.css
// module chunks = main